<template>
  <div>
    <!--我的证书-->
    <!--标题-->
    <p class="fav_mainHead">我的证书</p>
    <!--内容-->
    <div class="zs_list">
      <!--暂无证书提示-->
      <h5 class="none_ts" v-if="list.length == '0'">
        <img src="@/assets/images/none_data.jpg" alt="">
        <h4>暂无证书</h4>
      </h5>
      <!--暂无证书提示-->
      <dl v-if="list && list.length > 0" v-for="item in list" :key="item.id">
        <dt style="position: relative;">
          <span v-if="item.itemType== '99'" class="enroll_badge" style="position: absolute; top: -12px; left: -12px; z-index: 12;">公司证书</span>
          <span v-if="item.itemType== '98'" class="enroll_badge" style="position: absolute; top: -12px; left: -12px; z-index: 12;">个人证书</span>
          <span v-if="item.itemType== '05'" class="enroll_badge" style="position: absolute; top: -12px; left: -12px; z-index: 12;">计划证书</span>
          <a :href="item.certPath" target="_blank">
            <img :src="item.certPath" v-if="item.certPath">
          </a>
        </dt>
        <dd>{{item.title}}</dd>
      </dl>
    </div>
    <!--/我的证书-->
  </div>
</template>
<script>
export default {
  components: { },
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getCertList()
  },
  methods: {
    getCertList () {
      this.$api.post(this.$global.bylApiPath, '/cert/search', null, r => {
        if (r.data) {
          this.list = r.data
        }
      })
    }
  }
}
</script>
<style>
  .enroll_badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/uc/certificate.vue